import { ICommunicationError } from "@dev/hc-talk-talk";
import SetPasswordRequest from "@/app/dto/SetPasswordRequest";
import ApiError from "@/app/model/ApiError";
import OtpData from "@/app/model/OtpData";
import { createSha256HashWith1000Iterations } from "@/app/utils/PwdUtils";
import Api from "@/app/service/api";

class Password {
    public setPassword(password: string, customerUuid: string, otp: OtpData, authKey: string): Promise<void> {
        return new Promise((resolve, reject) => {
            const request = new SetPasswordRequest(
                createSha256HashWith1000Iterations(password)
            );
            Api.setPassword(customerUuid, authKey, otp, request)
                .then((response: any) => {
                    resolve();
                })
                .catch((error: ICommunicationError) => {
                    reject(new ApiError(error));
                });
        });
    }
}

export default new Password();
